export default "/images/vendor/flag-icon-css/flags/4x3/cr.svg?6f2d7bb05d9edb1089ec5bac86cf57c3";